import { Type } from '@angular/core';
import { ConfigurationId } from '@types';
import { TaxDisplayComponent } from './tax-component.interface';
import { UsCapitalGainsEstimatesComponent } from './us-capital-gains-estimates/us-capital-gains-estimates.component';
import { UsCapitalGainsComponent } from './us-capital-gains/us-capital-gains.component';
import { UsTaxComponent } from './us-tax/us-tax.component';
import { TaxListInfoComponent } from './tax-list-info/tax-list-info.component';

export class TaxConfig {
  static readonly US_TAX = new TaxConfig(
    'US Tax',
    UsTaxComponent,
    ConfigurationId.GW
  );
  static readonly US_CAPITAL_GAINS = new TaxConfig(
    'US Capital Gains',
    UsCapitalGainsComponent,
    ConfigurationId.GW
  );
  static readonly US_CAPITAL_GAINS_ESTIMATES = new TaxConfig(
    'US Capital Estimates',
    UsCapitalGainsEstimatesComponent,
    ConfigurationId.GW
  );

  static readonly TAX_LIST_INFO = new TaxConfig(
    'US Tax Info',
    TaxListInfoComponent,
    ConfigurationId.GW
  );

  static allConfigs: TaxConfig[] = [
    TaxConfig.US_TAX,
    TaxConfig.US_CAPITAL_GAINS,
    TaxConfig.US_CAPITAL_GAINS_ESTIMATES,
    TaxConfig.TAX_LIST_INFO,
  ];

  // returns matching config or undefined
  static getConfig(key: string, configurationName: ConfigurationId): TaxConfig {
    return this.allConfigs.find((config: TaxConfig): boolean =>
      config.configurationName
        ? config.key === key && config.configurationName === configurationName // if config is GW or ETF specific,make sure it matches
        : config.key === key
    ); // otherwise just match on key
  }

  private constructor(
    private readonly key: string,
    public readonly component: Type<TaxDisplayComponent>,
    public readonly configurationName?: ConfigurationId
  ) {}
}
